import React from 'react';
import Button from 'components/CustomButtons/Button';
import { translate } from 'components/Translation';

interface INavButtons {
	handleNext: Function;
	handleBack: Function;
	nextType: string;
	disabled?: boolean;
	nextText: string;
	className?: string;
}
export const NavButtons = ({ handleNext, handleBack, nextType, disabled, nextText, className }: INavButtons) => {
	return (
		<div className={className}>
			<Button color="primary-light" onClick={handleNext} type={nextType} disabled={disabled}>
				{nextText}
			</Button>
			<Button color="tertiary-light" onClick={handleBack}>
				{translate('back')}
			</Button>
		</div>
	);
};
